module.exports = __webpack_public_path__ + "static/media/james2.1a88a618.mp3";